import BookListContainer from './book-list';

export default BookListContainer;